export const UPDATE_FEATURE_KEY = 'update';

// The lock lives in memory only, so the update reload takes it with it. This flag carries the
// gate across that reload; it is the one piece of update state that must outlive the context.
export const UPDATE_RELOCK_KEY = 'update.relock';
